import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { TipoArquivoFormSelectModule } from '../../../../tipos/components/form-select';
import { ArquivoExtensaoPipeModule } from '../../../../extensoes/pipes';
import { FileUploadModule } from 'ng2-file-upload';

import { ArquivoUploadModalComponent } from './arquivo-upload-modal.component';

@NgModule({
    imports: [
        SharedModule,
        FileUploadModule,
        ArquivoExtensaoPipeModule,
        TipoArquivoFormSelectModule
    ],
    declarations: [
        ArquivoUploadModalComponent
    ],
    exports: [
        ArquivoUploadModalComponent
    ]
})
export class ArquivoUploadModalModule { }
